import React from 'react';
import { GetServerSideProps } from 'next';

import ShopRoutesClient from '../../_client/shop';
import SsrHead from '../../../src/pages/ProductDetailPage/SsrHead';

type KitDetailPageProps = {
  productKey: string;
};

const KitDetailPage = ({ productKey }: KitDetailPageProps) => (
  <>
    <SsrHead productKey={productKey} isKit />
    <ShopRoutesClient />
  </>
);

// eslint-disable-next-line @typescript-eslint/require-await
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { productKey } = context.params || {};
  return {
    props: {
      productKey: productKey as string,
    },
  };
};

export default KitDetailPage;
